export default "__VITE_ASSET__46f966e6__"